import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Box from 'components/box';
import {SearchFail} from 'components/common';
import Spinner from 'spinner';


import {Label, Select, UniversalDateTime, UniversalDateWrapper, UniversalSelectWrapper, UniversalSearchWrapper} from 'components/common';
import {ButtonDefault} from 'components/buttons';
import Input from 'form/input';

import {searchNewsAdmin, loadNewsTags} from 'redux/actions/portal/news';
import NewsList from './news-list';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import Pagination from 'pagination';
import {LinkDefault} from 'components/buttons';
import {PageHead} from 'components/header/components';

const mapStateToProps = (state) => ({
  news: state.news.get('newsAdminList'),
  tags: state.news.get('newsTags'),
  isFetching: state.news.get('newsAdminListAreLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    dispatch(loadNewsTags())
  },
  searchNews: (name, start_date, end_date, tag, current_status, offset) => {
    dispatch(searchNewsAdmin(name, start_date, end_date, tag, current_status, 10, offset))
  }
});

class NewsAll extends Component {

  constructor(props) {
    super(props);

    this.state = {
      start_date: moment("01-01-2018", "MM-DD-YYYY"),
      end_date: moment(),
      tag: "",
      search: '',
      currentStatus: ""
    }
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.searchByName = this.searchByName.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
  }

  searchByName(event) {
		this.setState({search: event.target.value})
	}

  onTagChange(event) {
    this.setState({
      tag: event.target.value,
    })
  }

  onStatusChange(event) {
    this.setState({
      currentStatus: event.target.value,
    })
  }

  onChangeStartDate(date) {
    this.setState({
      start_date: date
    })
  }

  onChangeEndDate(date) {
    this.setState({
      end_date: date
    })
  }

  onSubmitForm = event => {
    event.preventDefault();
    this.props.match.params.page != 1
      ? this.props.history.push(`/admin/news/1`)
      : this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag, this.state.currentStatus)
  }

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 10 * (page - 1);
    this.props.onLoad();
    this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag, this.state.current_status, offset)

	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 10 * (page - 1);
			this.props.searchNews(this.state.search, this.state.start_date, this.state.end_date, this.state.tag || this.props.tag, this.state.current_status, offset)
		}
	}

	render() {
    if (this.props.news.get('results') === undefined || this.props.tags === undefined) {
      return <Spinner/>;
    }
    const showTagsSelect = this.props.match.url.indexOf("news") !== -1;

    const { isFetching } = this.props;

    if (this.props.isFetching) {
      return <Spinner/>
    }
		return (
      <div>
			<Box>
				<PageHead>
					<h2>Реєстр новин</h2>
					<LinkDefault to="/admin/news/create">Створити новину</LinkDefault>
				</PageHead>

        {isFetching ? (
          <Spinner/>
        ):(

          <div>
          <UniversalSearchWrapper onSubmit={this.onSubmitForm}>
            <Input block="block" label="Пошук за назвою новини" placeholder="Введіть назву новини" value={this.state.search} onChange={this.searchByName}/>

        {showTagsSelect &&
            <UniversalSelectWrapper>
            <Label>Тег новини:</Label>
            {this.props.tags.get('results').size > 0 ? (
              <Select value={this.state.tag} onChange={this.onTagChange}>
                <option defaultValue value="">Всі теги</option>
                {this.props.tags.get('results').map(item => (
                  <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                ))}
              </Select>
            ):(
              <Select value={this.state.tag} onChange={this.onTagChange}>
                <option defaultValue value="">Всі теги</option>
                {this.props.tags.get('results').map(item => (
                  <option key={item.get('id')} value={item.get('id')}>{item.get('title')}</option>
                ))}
              </Select>
            )}
          </UniversalSelectWrapper>
        }

          <UniversalSelectWrapper>
          <Label>Стан: </Label>
                <Select onChange={this.onStatusChange}>
                  <option defaultValue value="">Всі стани</option>
                  <option value="draft">Чернетки</option>
                  <option value="public">Опубліковані</option>
              </Select>
          </UniversalSelectWrapper>


          <UniversalDateWrapper>
              <UniversalDateTime>
                <Label>Початкова дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.start_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeStartDate}
                />
              </UniversalDateTime>
              <UniversalDateTime>
                <Label>Кінцева дата</Label>
                <DatePicker
                  locale="uk-UA"
                  selected={this.state.end_date}
                  dateFormat="DD-MM-YYYY"
                  onChange={this.onChangeEndDate}
                />
              </UniversalDateTime>
            </UniversalDateWrapper>

          <ButtonDefault type="submit" value="Пошук" />
        </UniversalSearchWrapper>

          </div>
        )}

				{this.props.news.get('results').size > 0
						? (<div>
							{
								this.props.isFetching
									? (<Spinner/>)
									: (<NewsList news={this.props.news.get('results')}/>)
							}

						</div>)
						: (
							<SearchFail>Новини відсутні</SearchFail>
            )}

				  <Pagination counts={this.props.news.get('count')} path={`/admin/news/`} matched={this.props.match.params.page} limits={10}/>
			</Box>
		</div>
  )
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsAll));



// WEBPACK FOOTER //
// ./src/admin/news/news.js